import axios, { AxiosError, AxiosResponse } from 'axios';
import { push } from 'connected-react-router';
import Debug from 'utils/debug';
import { getXRequestId } from 'utils/getXRequestId';

import store from 'store';
import { setXRequestId } from 'store/autoReducers';

export const AXIOS_REQUEST = 'axiosRequests';

declare global {
    interface Window {
        qaState: {
            [AXIOS_REQUEST]: number;
        };
    }
}

window.qaState = {
    [AXIOS_REQUEST]: 0,
};

type IncrementRequests = () => void;
export const incrementRequests: IncrementRequests = () => {
    window.qaState[AXIOS_REQUEST] += 1;
};

type DecrementRequests = () => void;
export const decrementRequests: DecrementRequests = () => {
    window.qaState[AXIOS_REQUEST] -= 1;
};

type SetAccountToHeader = (accountId: string) => void;
export const setAccountToHeader: SetAccountToHeader = (accountId) => {
    axios.defaults.headers.common['X-Hh-Account-ID'] = accountId;
};

axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(
    (config) => {
        incrementRequests();
        return config;
    },
    (error) => Promise.reject(error)
);
axios.interceptors.response.use(
    (response: AxiosResponse<unknown>) => {
        decrementRequests();
        return response.data;
    },
    (err: AxiosError) => {
        decrementRequests();
        if (err && err.response) {
            const { status } = err.response;

            if (status >= 500) {
                const XRequestId = getXRequestId(err);
                store.dispatch(setXRequestId(XRequestId));
                store.dispatch(push('/new/error/'));
            }
        }
        if (err.code === 'ECONNABORTED') {
            Debug.log('error out', 'Timeout error', {
                message: err.message,
                url: err.config?.url,
            });
            store.dispatch(push('/new/unavailable/'));
        }
        return Promise.reject(err);
    }
);
axios.defaults.timeout = 60000;

export default Object.assign({}, axios);
